export class AppUserRole {
    public static role_Admin = "PLCAdmin";
    public static role_DevAccess = "DevAccess";
}